import BaseStore from './BaseStore'

export default class NewsStore extends BaseStore {}
